<template>
  <div>
    <o-widget-wrapper
      :schema="schema"
      :name="exAmountField"
      :validators="v.item"
      :server-errors="serverErrors"
      :form-state="formState"
    >
      <o-text-field
        :value="item[exAmountField]"
        @update="onExUpdated"
        @blur="calcInc"
        :form-state="formState"
        number
        type="number"
        step="0.01"
        :name="exAmountField"
        :validators="v.item"
        :server-errors="serverErrors"
        v-bind="schema.fields[exAmountField]"
        ><prepend>$</prepend><append>(ex GST)</append>
      </o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      :name="incAmountField"
      :validators="v.item"
      :server-errors="serverErrors"
      :form-state="formState"
    >
      <o-text-field
        :value="item[incAmountField]"
        @update="onIncUpdated"
        @blur="calcEx"
        type="number"
        step="0.01"
        :form-state="formState"
        :name="incAmountField"
        :validators="v.item"
        :server-errors="serverErrors"
        v-bind="schema.fields[incAmountField]"
        ><prepend>$</prepend><append>(inc GST)</append></o-text-field
      >
    </o-widget-wrapper>
  </div>
</template>

<script>
export default {
  name: "TaxInputs",
  props: {
    item: { type: Object },
    exAmountField: { type: String, default: "amount_ex" },
    incAmountField: { type: String, default: "amount_inc" },
    taxAmount: { type: Number, default: 1.1 },
    formState: { type: Object, default: () => {} },
    schema: { type: Object, default: () => {} },
    v: { type: Object, default: () => {} },
    serverErrors: { type: Object, default: () => {} },
  },
  methods: {
    onExUpdated: function (exValue) {
      this.item[this.exAmountField] = exValue;
    },
    calcInc: function () {
      var exValue = +this.item[this.exAmountField];
      if (_.isFinite(exValue)) {
        this.item[this.exAmountField] = exValue.toFixed(2);
        this.$set(
          this.item,
          this.incAmountField,
          (exValue * this.taxAmount).toFixed(2)
        );
      }
    },

    onIncUpdated: function (incValue) {
      this.item[this.incAmountField] = incValue;
    },
    calcEx: function () {
      var incValue = +this.item[this.incAmountField];
      if (_.isFinite(incValue)) {
        this.item[this.incAmountField] = incValue.toFixed(2);
        this.$set(
          this.item,
          this.exAmountField,
          (incValue / this.taxAmount).toFixed(2)
        );
      }
    },
  },
};
</script>

<style scoped></style>
